module.exports = __webpack_public_path__ + "img/Paladin-dwarf-m-60.810031fe.gif";